import { event } from '.'

export const gtagBeginCheckout = () => {
  event({
    action: 'begin_checkout',
  })
}
